import { ScrollAdDispatcher } from "./ScrollAdDispatcher";
import { StripChatAdDispatcher } from "./stripChat/StripChatAdDispatcher";
import { AdUnitsKeys } from "./config/units";
import { memo } from "react";

interface IProps {
  position: number;
  fullscreen: boolean;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

export const FeedAds = memo(({ position, fullscreen, mobileAds, desktopAds } : IProps) => {
  return !fullscreen ? (
    <ScrollAdDispatcher
      position={position + 1}
      mobileAds={mobileAds}
      desktopAds={desktopAds}
    />
  ) : (
    <StripChatAdDispatcher
      position={position}
    />
  );
});
